// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// primary drawer
export const REPLACE_PRIMARY_DRAWER = 'REPLACE_PRIMARY_DRAWER'

// products
export const REPLACE_LOADING_PRODUCTS = 'REPLACE_LOADING_PRODUCTS'
export const REPLACE_PRODUCTS = 'REPLACE_PRODUCTS'
export const REPLACE_SHOW_MODAL_DELETE_PRODUCT =
  'REPLACE_SHOW_MODAL_DELETE_PRODUCT'
export const REPLACE_CURRENT_PRODUCT = 'REPLACE_CURRENT_PRODUCT'
export const REPLACE_LOADING_CURRENT_PRODUCT =
  'REPLACE_LOADING_CURRENT_PRODUCT'
export const REPLACE_LOADING_COST_PRODUCT_BY_LOTS =
  'REPLACE_LOADING_COST_PRODUCT_BY_LOTS'
export const REPLACE_COST_PRODUCTS_BY_LOTS = 'REPLACE_COST_PRODUCTS_BY_LOTS'
// type users
export const REPLACE_LOADING_TYPE_USERS = 'REPLACE_LOADING_TYPE_USERS'
export const REPLACE_TYPE_USERS = 'REPLACE_TYPE_USERS'
// universidades
export const REPLACE_LOADING_UNIVERSIDADES = 'REPLACE_LOADING_UNIVERSIDADES'
export const REPLACE_UNIVERSIDADES = 'REPLACE_UNIVERSIDADES'

// users
export const REPLACE_SHOW_MODAL_LOGIN = 'REPLACE_SHOW_MODAL_LOGIN'
export const REPLACE_SHOW_MODAL_REQUEST_RETIREMENT =
  'REPLACE_SHOW_MODAL_REQUEST_RETIREMENT'
export const REPLACE_SHOW_MODAL_SUBSCRIPTION =
  'REPLACE_SHOW_MODAL_SUBSCRIPTION'
export const REPLACE_SHOW_MODAL_UNSUBSCRIBE = 'REPLACE_SHOW_MODAL_UNSUBSCRIBE'
export const REPLACE_SHOW_MODAL_UPDATE_NETELLER_ACCOUNTS =
  'REPLACE_SHOW_MODAL_UPDATE_NETELLER_ACCOUNTS'
export const REPLACE_LOADING_USERS = 'REPLACE_LOADING_USERS'
export const REPLACE_USERS = 'REPLACE_USERS'
export const REPLACE_SHOW_MODAL_DELETE_USER = 'REPLACE_SHOW_MODAL_DELETE_USER'
export const REPLACE_CURRENT_USER = 'REPLACE_CURRENT_USER'
export const REPLACE_LOADING_CURRENT_USER = 'REPLACE_LOADING_CURRENT_USER'
export const REPLACE_PURCHASES_BY_USER = 'REPLACE_PURCHASES_BY_USER'
export const REPLACE_LOADING_PURCHASES_BY_USER =
  'REPLACE_LOADING_PURCHASES_BY_USER'
export const REPLACE_LOADING_SUBSCRIPTIONS_BY_USER =
  'REPLACE_LOADING_SUBSCRIPTIONS_BY_USER'
export const REPLACE_SUBSCRIPTIONS_BY_USER = 'REPLACE_SUBSCRIPTIONS_BY_USER'
export const REPLACE_USER_CAN_TAKE_MONEY = 'REPLACE_USER_CAN_TAKE_MONEY'

// registereds
export const REPLACE_LOADING_REGISTEREDS = 'REPLACE_LOADING_REGISTEREDS'
export const REPLACE_CURRENT_REGISTERED = 'REPLACE_CURRENT_REGISTERED'
export const REPLACE_REGISTEREDS = 'REPLACE_REGISTEREDS'
export const REPLACE_SHOW_MODAL_ABILITY = 'REPLACE_SHOW_MODAL_ABILITY'
export const REPLACE_SHOW_MODAL_DELETE_INSCRIBED =
  'REPLACE_SHOW_MODAL_DELETE_INSCRIBED'
export const REPLACE_LOADING_ANNULLED = 'REPLACE_LOADING_ANNULLED'
export const REPLACE_ANNULLED = 'REPLACE_ANNULLED'

// careers
export const REPLACE_LOADING_CAREERS = 'REPLACE_LOADING_CAREERS'
export const REPLACE_CAREERS = 'REPLACE_CAREERS'
// countries
export const REPLACE_LOADING_COUNTRIES = 'REPLACE_LOADING_COUNTRIES'
export const REPLACE_COUNTRIES = 'REPLACE_COUNTRIES'
// regions
export const REPLACE_LOADING_REGIONS = 'REPLACE_LOADING_REGIONS'
export const REPLACE_REGIONS = 'REPLACE_REGIONS'
// provinces
export const REPLACE_LOADING_PROVINCES = 'REPLACE_LOADING_PROVINCES'
export const REPLACE_PROVINCES = 'REPLACE_PROVINCES'
// districts
export const REPLACE_LOADING_DISTRICTS = 'REPLACE_LOADING_DISTRICTS'
export const REPLACE_DISTRICTS = 'REPLACE_DISTRICTS'
// languages
export const REPLACE_LOADING_LANGUAGES = 'REPLACE_LOADING_LANGUAGES'
export const REPLACE_LANGUAGES = 'REPLACE_LANGUAGES'
// schools
export const REPLACE_LOADING_SCHOOLS = 'REPLACE_LOADING_SCHOOLS'
export const REPLACE_SCHOOLS = 'REPLACE_SCHOOLS'
export const REPLACE_LOADING_LEVELS = 'REPLACE_LOADING_LEVELS'
export const REPLACE_LEVELS = 'REPLACE_LEVELS'
export const REPLACE_LOADING_MANAGEMENTS = 'REPLACE_LOADING_MANAGEMENTS'
export const REPLACE_MANAGEMENTS = 'REPLACE_MANAGEMENTS'

// type_exams
export const REPLACE_LOADING_TYPE_EXAMS = 'REPLACE_LOADING_TYPE_EXAMS'
export const REPLACE_LOADING_TYPE_EXAMS_ENABLED = 'REPLACE_LOADING_TYPE_EXAMS_ENABLED'
export const REPLACE_TYPE_EXAMS = 'REPLACE_TYPE_EXAMS'
export const REPLACE_EXTRA_EXAMS = 'REPLACE_EXTRA_EXAMS'
export const REPLACE_COMMUNITIES = 'REPLACE_COMMUNITIES'
export const REPLACE_PLACES = 'REPLACE_PLACES'

// cepre
export const REPLACE_LOADING_REGISTEREDS_CEPRE =
  'REPLACE_LOADING_REGISTEREDS_CEPRE'
export const REPLACE_REGISTEREDS_CEPRE = 'REPLACE_REGISTEREDS_CEPRE'
export const REPLACE_SHOW_MODAL_PAYMENTS = 'REPLACE_SHOW_MODAL_PAYMENTS'
export const REPLACE_CURRENT_REGISTERED_CEPRE =
  'REPLACE_CURRENT_REGISTERED_CEPRE'
